import { semanticThemeTokens } from "../theme/ThemeTokens.css";

/**
 * Basic component for displaying the Appretio logo.
 *
 * It is styled via the semantic theme tokens, so will adapt to the current theme.
 * The logo will automatically take the full size of the parent component.
 */
export function Logo() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 162 32"
      fill="none"
      preserveAspectRatio="xMidYMid meet"
      data-testid="logo"
    >
      <path
        d="M44.6409 27.1676L52.3728 7.83782H54.72L62.4795 27.1676H59.4696L57.8403 23.0531H49.1972L47.568 27.1676H44.6409ZM50.2189 20.4574H56.8186L54.8028 15.3212C53.9744 13.1949 53.5602 11.5381 53.5602 11.5381C53.5602 11.5381 53.0907 13.1949 52.2623 15.3212L50.2189 20.4574Z"
        fill={semanticThemeTokens.logo.fill}
      />
      <path
        d="M72.7844 27.4713C70.4372 27.4713 68.5043 26.5324 67.2893 24.9032V32H64.6107V12.3665H67.0131V15.0174C68.2281 13.1397 70.2716 12.0627 72.7844 12.0627C76.8989 12.0627 80.0745 15.4317 80.0745 19.7394C80.0745 24.0748 76.8713 27.4713 72.7844 27.4713ZM67.2893 19.7394C67.2893 22.7493 69.4155 24.9585 72.3426 24.9585C75.1869 24.9585 77.396 22.6389 77.396 19.7394C77.396 16.8676 75.1869 14.6032 72.3426 14.6032C69.4155 14.6032 67.2893 16.7847 67.2893 19.7394Z"
        fill={semanticThemeTokens.logo.fill}
      />
      <path
        d="M91.2297 27.4713C88.8825 27.4713 86.9495 26.5324 85.7345 24.9032V32H83.056V12.3665H85.4584V15.0174C86.6734 13.1397 88.7168 12.0627 91.2297 12.0627C95.3441 12.0627 98.5198 15.4317 98.5198 19.7394C98.5198 24.0748 95.3165 27.4713 91.2297 27.4713ZM85.7345 19.7394C85.7345 22.7493 87.8608 24.9585 90.7878 24.9585C93.6321 24.9585 95.8412 22.6389 95.8412 19.7394C95.8412 16.8676 93.6321 14.6032 90.7878 14.6032C87.8608 14.6032 85.7345 16.7847 85.7345 19.7394Z"
        fill={semanticThemeTokens.logo.fill}
      />
      <path
        d="M101.501 27.1676V12.3665H103.931V15.0727C104.787 13.1673 106.334 12.0627 108.239 12.0627C110.448 12.0627 111.829 13.4987 112.16 16.0944L109.509 16.5914C109.371 15.2936 108.57 14.6308 107.466 14.6308C105.864 14.6308 104.18 16.5638 104.18 20.3193V27.1676H101.501Z"
        fill={semanticThemeTokens.logo.fill}
      />
      <path
        d="M120.698 27.4713C116.252 27.4713 112.966 24.2681 112.966 19.767C112.966 15.3764 116.252 12.0627 120.45 12.0627C124.481 12.0627 127.547 15.1279 127.547 19.1043C127.547 19.4357 127.519 20.0432 127.464 20.3193H115.617C115.893 23.1912 117.937 24.9861 120.615 24.9861C122.88 24.9861 124.481 23.992 124.868 22.1971L127.602 22.4732C126.829 25.6212 124.399 27.4713 120.698 27.4713ZM115.783 18.0274H124.675C124.592 16.0115 122.88 14.4652 120.422 14.4652C118.047 14.4652 116.335 15.8735 115.783 18.0274Z"
        fill={semanticThemeTokens.logo.fill}
      />
      <path
        d="M135.826 27.3609C132.982 27.3609 131.215 25.6212 131.215 22.2799V14.6308H128.453V12.3665H131.215V8.44532H133.893V12.3665H137.704V14.6308H133.893V22.059C133.893 24.2405 134.943 25.0137 136.268 25.0137C137.069 25.0137 137.566 24.7375 137.759 24.6547L137.98 26.919C137.704 27.0571 136.959 27.3609 135.826 27.3609Z"
        fill={semanticThemeTokens.logo.fill}
      />
      <path
        d="M140.603 27.1676V12.3665H143.281V27.1676H140.603ZM140.465 9.52226V6.45712H143.42V9.52226H140.465Z"
        fill={semanticThemeTokens.logo.fill}
      />
      <path
        d="M153.948 27.4713C149.585 27.4713 146.243 24.13 146.243 19.7947C146.243 15.404 149.585 12.0627 153.948 12.0627C158.311 12.0627 161.679 15.404 161.679 19.7947C161.679 24.13 158.311 27.4713 153.948 27.4713ZM148.922 19.7947C148.922 22.6941 151.103 24.9308 153.948 24.9308C156.792 24.9308 159.001 22.6941 159.001 19.7947C159.001 16.84 156.792 14.6032 153.948 14.6032C151.103 14.6032 148.922 16.84 148.922 19.7947Z"
        fill={semanticThemeTokens.logo.fill}
      />
      <path
        d="M11.6362 8.90264L13.9756 0.480866C14.0544 0.197001 14.3126 0.000460869 14.6072 0H15.4163C15.711 0.000240453 15.9695 0.196851 16.0484 0.480866L18.3887 8.90602C18.8272 10.3407 20.1529 11.3262 21.66 11.3262L28.5542 11.3263C29.2795 11.3263 29.8674 11.9142 29.8674 12.6395V28.2337C29.8674 28.959 29.2795 29.5469 28.5542 29.5469H25.1203C24.5304 29.5469 24.0129 29.1535 23.8551 28.5852L19.7716 16.6472C19.3529 15.1348 17.9764 14.0877 16.4072 14.0877H13.6178C12.0485 14.0877 10.6721 15.1348 10.2533 16.6472L6.16876 28.5852C6.01088 29.1535 5.49337 29.5469 4.90347 29.5469H1.63373C0.908472 29.5469 0.320534 28.959 0.320534 28.2337V12.6395C0.320534 11.9142 0.908472 11.3263 1.63373 11.3263L8.36386 11.3262C9.87208 11.3262 11.1987 10.3391 11.6362 8.90264Z"
        fill={semanticThemeTokens.logo.fill}
      />
    </svg>
  );
}
